<template>
  <div class="c-campaign-schedule-form">
    <el-form
        ref="form"
        :model="campaignScheduleForm"
        label-position="top"
        label-width="120px"
        @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Activate Campaign Scheduling">
            <el-switch v-model="campaignScheduleForm.scheduling_enabled"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div :class="[{ disabled: !campaignScheduleForm.scheduling_enabled }, 'schedule-details']">
            <el-form-item>
              <el-switch
                  v-model="scheduleHasEndDate"
                  inactive-text="Specify end date"></el-switch>
            </el-form-item>

            <el-form-item class="!mb-0">
              <el-date-picker
                  v-model="date"
                  class="gray"
                  :type="datePickerType"
                  :format="'yyyy-MM-dd HH:mm'"
                  range-separator="Until"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
          </div>
        </el-col>

      </el-row>
    </el-form>
  </div>
</template>
<script>

export default {
  name: 'CampaignScheduleForm',
  data() {
    return {
      enableUpdate: false,
      scheduleHasEndDate: true,
      campaignScheduleForm: {
        scheduled_from: null,
        scheduled_to: null,
        scheduling_enabled: false,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
    }
  },
  computed: {
    campaign() {
      return this.$store.getters['campaign/targetCampaign']
    },
    datePickerType() {
      return this.scheduleHasEndDate ? 'datetimerange' : 'datetime'
    },
    date: {
      get: function () {
        if (this.scheduleHasEndDate) {
          const dateArr = ['', '']

          if (this.campaignScheduleForm.scheduled_from != null) {
            dateArr[0] = this.campaignScheduleForm.scheduled_from

            if (this.campaignScheduleForm.scheduled_to != null) {
              dateArr[1] = this.campaignScheduleForm.scheduled_to
            }
          }
          return dateArr
        } else {
          return this.campaignScheduleForm.scheduled_from
        }
      },
      set: function (newValue) {
        if (newValue != null) {
          if (this.scheduleHasEndDate) {
            this.campaignScheduleForm.scheduled_from = newValue[0]
            this.campaignScheduleForm.scheduled_to = newValue[1]
          } else {
            this.campaignScheduleForm.scheduled_from = newValue
          }
        } else {
          if (this.scheduleHasEndDate) {
            this.campaignScheduleForm.scheduled_from = null
            this.campaignScheduleForm.scheduled_to = null
          } else {
            this.campaignScheduleForm.scheduled_from = null
          }
        }
      },
    },
  },
  watch: {
    campaign(val) {
      this.setFormValues(val)
    },
    campaignScheduleForm: {
      handler() {
        if (this.enableUpdate) {
          this.$emit('update', this.campaignScheduleForm)
        }
      },
      deep: true,
      immediate: false,
    },
  },
  created() {
    this.setFormValues(this.campaign)
    this.$nextTick(() => {
      this.enableUpdate = true
    })
  },
  methods: {
    setFormValues(campaign) {
      const newValue = JSON.parse(JSON.stringify(campaign))

      if (newValue.scheduled_to == null) {
        this.scheduleHasEndDate = false
        newValue.scheduled_to = null
      }

      if (newValue.scheduled_from == null) {
        newValue.scheduled_from = null
      }

      this.campaignScheduleForm.scheduling_enabled = newValue.scheduling_enabled
      this.campaignScheduleForm.scheduled_from = newValue.scheduled_from
      this.campaignScheduleForm.scheduled_to = newValue.scheduled_to
    },
  },
}
</script>

<style lang="scss">
.c-campaign-schedule-form {
  .schedule-details.disabled {
    pointer-events: none;
    opacity: 0.4;
  }

  .el-range-editor.el-input__inner {
    width: 500px;
  }

  .el-range-separator {
    width: 100px;
  }

  .el-switch__label {
    @apply text-onvocado-primary;

    &.is-active {
      color: #303133;
    }
  }

  .mdc-drawer__drawer {
    will-change: unset;
  }
}
</style>
